/**
 * Stats Page
 * Admin-only analytics dashboard with tabs for extension, crawler,
 * cross-project, and worker statistics.
 */

import { useState } from 'react';
import { Tabs, Button, Space } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useQueryClient } from '@tanstack/react-query';
import { PageHeader } from '@/components/common/PageHeader';
import { ExtensionTab, CrawlerTab, CrossProjectTab, WorkersTab } from '@/components/stats';
import { projectStatsKeys } from '@/hooks/useProjectStats';

type TabKey = 'extension' | 'crawler' | 'cross-project' | 'workers';

export function StatsPage() {
  const [activeTab, setActiveTab] = useState<TabKey>('cross-project');
  const queryClient = useQueryClient();

  const handleRefresh = () => {
    queryClient.invalidateQueries({ queryKey: projectStatsKeys.all });
  };

  return (
    <div>
      <PageHeader
        title="Stats"
        description="Analytics across extension, crawler, and worker systems"
        extra={
          <Space>
            <Button icon={<ReloadOutlined />} onClick={handleRefresh}>
              Refresh
            </Button>
          </Space>
        }
      />

      <Tabs
        activeKey={activeTab}
        onChange={(key) => setActiveTab(key as TabKey)}
        items={[
          {
            key: 'cross-project',
            label: 'Overview',
            children: <CrossProjectTab />,
          },
          {
            key: 'extension',
            label: 'Extension',
            children: <ExtensionTab />,
          },
          {
            key: 'crawler',
            label: 'Crawler',
            children: <CrawlerTab />,
          },
          {
            key: 'workers',
            label: 'Workers',
            children: <WorkersTab />,
          },
        ]}
        style={{ marginTop: 16 }}
      />
    </div>
  );
}
